import { Action } from "redux";
import { INotification } from "../../common/sharedTypes";
import { INotificationType } from "../NotificationTemplate/business-objects/common";
import { QueuedNotificationSearchItem } from "./business-objects/common";

export interface IQueuedNotificationState {
  notifications: INotification[];
  sentNotifications: INotification[];
  notificationTypes: INotificationType[];
  pagedSentNotifications: QueuedNotificationSearchItem[];
  pagedNotifications: QueuedNotificationSearchItem[];
  totalNotifications: number;
  loadingNotifications: boolean;
  totalSentNotifications: number;
  loadingSentNotifications: boolean;
}

// ACTIONS
export interface IGetQueuedNotificationsAction extends Action {
  type: "@@qnotification/GET_QUEUED_NOTIFICATIONS";
  payload: {};
}

export interface ISendSelectedAction extends Action {
  type: "@@qnotification/SEND_SELECTED";
  payload: {};
}

export enum QNotificationActionTypes {
  GET_QUEUED_NOTIFICATIONS = "@@qnotification/GET_QUEUED_NOTIFICATIONS",
  GET_SENT_NOTIFICATIONS = "@@qnotification/GET_SENT_NOTIFICATIONS",
  SEND_SELECTED = "@@qnotification/SEND_SELECTED",
  REFRESH_SENT = "@@qnotification/REFRESH_SENT",
  REMOVE_PRINTED = "@@qnotification/REMOVE_PRINTED",
  UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION",
  ADD_NOTIFICATION = "ADD_NOTIFICATION",
  LOADING_NOTIFICATIONS = "@@qnotification/LOADING_NOTIFICATIONS",
  TOTAL_NOTIFICATIONS = "@@qnotification/TOTAL_NOTIFICATIONS",
  SET_PAGED_NOTIFICATIONS = "@@qnotification/SET_PAGED_NOTIFICATIONS",
  GET_QUEUED_NOTIFICATIONS_PAGED = "@@qnotification/GET_QUEUED_NOTIFICATIONS_PAGED",
  SET_PAGED_SENT_NOTIFICATIONS = "@@qnotification/SET_PAGED_SENT_NOTIFICATIONS",
  REFRESH_PAGED_SENT = "@@qnotification/REFRESH_PAGED_SENT",
  LOADING_SENT_NOTIFICATIONS = "@@qnotification/LOADING_SENT_NOTIFICATIONS",
  TOTAL_SENT_NOTIFICATIONS = "@@qnotification/TOTAL_SENT_NOTIFICATIONS",
}

export type QNotificationActions = IGetQueuedNotificationsAction | ISendSelectedAction;
